var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-action-button is-hidden-desktop"},[_c('BButton',{attrs:{"type":_vm.buttonType,"rounded":""},on:{"click":_vm.onClick}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }